import { IPosition, TPopupHorizontal, TPopupVertical } from '../interface/position'

export const getDirectionByPosition = (
  position: IPosition,
  horizontalDirection?: TPopupHorizontal,
  verticalDirection?: TPopupVertical
) => {
  let horizontal = position.left !== undefined ? TPopupHorizontal.Right : TPopupHorizontal.Left
  let vertical = position.top !== undefined ? TPopupVertical.Bottom : TPopupVertical.Top

  if (horizontalDirection === TPopupHorizontal.Center) {
    horizontal = TPopupHorizontal.Center
  }
  if (verticalDirection === TPopupVertical.Center) {
    vertical = TPopupVertical.Center
  }
  return {
    horizontal,
    vertical,
  }
}
